import { Component, OnInit, Input } from '@angular/core';
import { ErrorInterface, HttpErrorInterface } from '../../models/error';

@Component({
  selector: 'lib-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {

  @Input() title!: string;
  @Input() error!: HttpErrorInterface;
  showInnerException: boolean = false;

  constructor() { }

  get e(): ErrorInterface { return this.error.error }

  ngOnInit(): void {
    console.log(this.error);
  }

}
